// src/pages/Immobilier.js
// Page catégorie Immobilier - affiche les vraies données uniquement - NE PAS MODIFIER

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import ListingGrid from '../components/listing/ListingGrid';
import CategoryBar from '../components/home/CategoryBar';
import apiClient from '../api/client';

const Immobilier = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadListings = async () => {
      setLoading(true);
      try {
        const result = await apiClient.get('/endpoints/listings.php?action=list&status=published&category=immobilier&limit=100');
        setListings(result.listings || []);
      } catch (err) {
        setListings([]);
      } finally {
        setLoading(false);
      }
    };
    loadListings();
  }, []);

  const styles = {
    container: { display: 'flex', flexDirection: 'column', minHeight: '100vh' },
    header: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      padding: '16px',
      position: 'sticky',
      top: 0,
      backgroundColor: '#0A0E1A',
      zIndex: 50,
      borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
    },
    backButton: {
      background: 'none',
      border: 'none',
      color: '#FFFFFF',
      fontSize: '20px',
      cursor: 'pointer',
      padding: '4px',
    },
    title: { fontSize: '20px', fontWeight: '700', color: '#FFFFFF' },
    subtitle: { padding: '8px 16px', fontSize: '14px', color: '#A0AEC0' },
  };

  return (
    <div style={styles.container}>
      <Helmet>
        <title>Terrains et propriétés à vendre au Cameroun | Fynho</title>
        <meta name="description" content="Parcelles viabilisées, terrains avec titre foncier et propriétés à vendre au Cameroun." />
        <meta name="keywords" content="terrain à vendre Cameroun, parcelle Douala, titre foncier, terrain viabilisé, propriété Yaoundé" />
        <link rel="canonical" href="https://fynho.com/immobilier" />
      </Helmet>

      <div style={styles.header}>
        <button style={styles.backButton} onClick={() => navigate('/')}>←</button>
        <div style={styles.title}>🌍 {t('categories.immobilier')}</div>
      </div>

      <CategoryBar />

      <div style={styles.subtitle}>
        Parcelles et propriétés à vendre · {listings.length} annonce{listings.length !== 1 ? 's' : ''}
      </div>

      <ListingGrid listings={listings} loading={loading} />
    </div>
  );
};

export default Immobilier;